import { FormControlLabel, Switch } from "@mui/material";
import { message } from "antd";
import React, { useEffect, useState } from "react";
import DyanmicFrom from "../../../DyanmicForm/DyanmicFrom";
import CustomSubmit from "../Custom2StageForm/CustomSubmit";
import DataCard from "../DataCard";
import FormCard1 from "./FormCard1";
import Level3Card from "./Level3Card";
import PropTypes from "prop-types";
const Level4Card = ({
  error,
  fields,
  preview,
  updateComponentData,
  dataCard,
  page_id,
  setDataCard,
  children,
  oldData,
  level1,
  level2,
  level3,
}) => {
  const [active, setActive] = useState(false);

  const [activeSection, setActiveSection] = useState();

  useEffect(() => {
    if (oldData) setDataCard(oldData);
  }, [oldData]);
  useEffect(() => {
    setActive(preview);
  }, [preview]);

  const addData = (index, cardData, type) => {
    let array = [];
    if (type) {
      array = [...dataCard.dataArray];
      array[index] = cardData;
    } else if (dataCard.dataArray) array = [...dataCard.dataArray, cardData];
    else array = [cardData];
    setDataCard({ ...dataCard, dataArray: array });
    if (type) {
      message.success("data updated click on publish to publish changes");
    } else {
      message.success("Created");
    }
  };

  const handleUp = (index) => {
    let arr = dataCard?.dataArray;
    if (index > 0) {
      let val = dataCard?.dataArray[index];
      let val1 = dataCard?.dataArray[index - 1];
      arr[index] = val1;
      arr[index - 1] = val;
      setDataCard({ ...dataCard, dataArray: arr });
    }
  };

  const handleDown = (index) => {
    let arr = dataCard?.dataArray;
    if (index < arr.length - 1) {
      let val = dataCard?.dataArray[index];
      let val1 = dataCard?.dataArray[index + 1];
      arr[index] = val1;
      arr[index + 1] = val;
      setDataCard({ ...dataCard, dataArray: arr });
    }
  };

  const handleChange = (event) => {
    setActive(event.target.checked);
  };
  return (
    <div className="card">
      <div
        style={{
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "flex-end",
        }}
      >
        {" "}
        <FormControlLabel
          control={<Switch checked={active} onChange={handleChange} />}
          label="Preview"
        />
      </div>
      {active && children}

      {!active && (
        <div className="card-body">
          <div className="row">
            <DyanmicFrom
              error={error}
              attributes={fields || []}
              data={dataCard}
              level={1}
              setData={(e) => {
                setDataCard(e);
              }}
            />
          </div>
          {dataCard?.dataArray?.map((item, index) => (
            <DataCard
              title={item?.title}
              index={index}
              key={index + ""}
              handleup={handleUp}
              handledown={handleDown}
              activeDrop={activeSection}
              setActiveDrop={setActiveSection}
              array={dataCard?.dataArray}
              setArray={(e) => {
                setDataCard({ ...dataCard, dataArray: e });
              }}
            >
              <FormCard1
                active={activeSection === index}
                attributes={level1}
                data={item}
                updateData={(index, cardData, type) => {
                  addData(
                    index,
                    { ...cardData, dataArray: item?.dataArray },
                    type
                  );
                }}
                index={index + 1}
              />

              <Level3Card
                hidepreview={true}
                item={item}
                index={index}
                level1={level2}
                level2={level3}
                key={index + ""}
                dataCard={dataCard?.dataArray?.[index] || { dataArray: [] }}
                setDataCard={(item) => {
                  let arr = dataCard?.dataArray || [];
                  arr[index] = item;
                  setDataCard({
                    ...dataCard,
                    dataArray: arr,
                  });
                }}
              />
            </DataCard>
          ))}
          <FormCard1 add updateData={addData} />
          {page_id && (
            <CustomSubmit
              data1={dataCard}
              data2={oldData}
              handleSubmit={() => updateComponentData(dataCard)}
            />
          )}
        </div>
      )}
    </div>
  );
};
Level4Card.propTypes = {
  error: PropTypes.any,
  fields: PropTypes.any,
  preview: PropTypes.any,
  updateComponentData: PropTypes.any,
  dataCard: PropTypes.any,
  page_id: PropTypes.any,
  setDataCard: PropTypes.any,
  children: PropTypes.any,
  oldData: PropTypes.any,
  level1: PropTypes.any,
  level2: PropTypes.any,
  level3: PropTypes.any,
};

export default Level4Card;
